"use client";

import { Skeleton } from "@/components/ui/skeleton";
import { handleParse } from "@/lib/handleParse";
import { TextSektion } from "@/types/page";
import React from "react";

export default function TextSektionLayout({
  content,
}: {
  content: TextSektion;
}) {
  return (
    <section className="layout md:grid md:grid-cols-2 ">
      <div>{content?.text && handleParse(content.text)}</div>
    </section>
  );
}

export function TextSektionSkeleton() {
  return (
    <section className="layout md:grid md:grid-cols-2">
      <div className="space-y-4">
        {/* Heading */}
        <Skeleton className="h-7 w-4/5 mb-2" />

        {/* Text paragraphs */}
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-5 w-11/12" />
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-5 w-4/5" />
        <Skeleton className="h-5 w-3/4" />

        {/* Possible subheading */}
        <Skeleton className="h-6 w-1/2 mt-6 mb-2" />

        {/* More paragraphs */}
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-5 w-full" />
      </div>
    </section>
  );
}
